class CountdownBanner extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.initCountdown();
  }

  initCountdown() {
    const timer = this.querySelector('.countdown-timer');
    if (!timer) return;

    const bannerId = timer.dataset.bannerId;
    const originalEndTimeStr = timer.dataset.endTime;
    const resetEveryMidnight = timer.dataset.resetEveryMidnight === 'true';
    const banner = document.getElementById(bannerId);

    const timeKey = `${bannerId}-local-time`;

    let activeEndTimeStr = localStorage.getItem(timeKey) || originalEndTimeStr;

    let endTime = new Date(activeEndTimeStr.replace(/-/g, '/')).getTime();
    const now = Date.now();

    if (now >= endTime && resetEveryMidnight) {
      let lastEndTimestamp = endTime;
      const twentyFourHoursInMillis = 24 * 60 * 60 * 1000;

      while (lastEndTimestamp < now) {
        lastEndTimestamp += twentyFourHoursInMillis;
      }

      endTime = lastEndTimestamp;

      const newEndDate = new Date(endTime);

      const year = newEndDate.getFullYear();
      const month = (newEndDate.getMonth() + 1).toString().padStart(2, '0');
      const day = newEndDate.getDate().toString().padStart(2, '0');
      const hours = newEndDate.getHours().toString().padStart(2, '0');
      const minutes = newEndDate.getMinutes().toString().padStart(2, '0');
      const seconds = newEndDate.getSeconds().toString().padStart(2, '0');
      activeEndTimeStr = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

      localStorage.setItem(timeKey, activeEndTimeStr);
    }

    if (now >= endTime) {
      if (banner) banner.style.display = 'none';
      return; // Stop execution.
    }

    if (banner) banner.style.display = '';

    const daysEl = timer.querySelector('.days');
    const hoursEl = timer.querySelector('.hours');
    const minsEl = timer.querySelector('.minutes');
    const secsEl = timer.querySelector('.seconds');

    const updateCountdown = () => {
      const nowTime = Date.now();
      const distance = endTime - nowTime;

      if (distance < 0) {
        clearInterval(countdownInterval);
        if (resetEveryMidnight) {
          this.initCountdown();
        } else {
          if (banner) banner.style.display = 'none';
        }
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = days.toString().padStart(2, '0');
      if (hoursEl) hoursEl.textContent = hours.toString().padStart(2, '0');
      if (minsEl) minsEl.textContent = minutes.toString().padStart(2, '0');
      if (secsEl) secsEl.textContent = seconds.toString().padStart(2, '0');
    };

    const countdownInterval = setInterval(updateCountdown, 1000);
  }
}

if (!customElements.get('countdown-banner')) {
  customElements.define('countdown-banner', CountdownBanner);
}
